// extracted by mini-css-extract-plugin
export var divider = "_yt-0";